var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAdContainer',{attrs:{"placeholder":_vm.placeholder,"container-size":_vm.containerSize,"container-size-mapping":_vm.sizeMapping}},[_c('CAdTarget',{staticClass:"c-ga",attrs:{"id":_vm.ad.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }